import { useMutation } from '@tanstack/react-query';
import { getProjectKeywords } from '../../../services/project/options/ProjectOptionsService';

export const useGetProjectOptionsKeywords = () => {
  const {
    mutateAsync: fetchProjectOptionsKeywords,
    data: keywords,
    isPending: isLoading,
    isError,
    error,
    reset,
  } = useMutation<string[], Error, { projectId: number }>({
    mutationFn: ({ projectId }) => getProjectKeywords(projectId),
  });

  return {
    fetchProjectOptionsKeywords,
    keywords,
    isLoading,
    isError,
    error,
    reset,
  };
};
